module.exports = __webpack_public_path__ + "img/colored-rounded.94f40017.svg";